import $ from 'jquery';
import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import { Markdown } from 'tiptap-markdown';
import View from 'view/base';

export default View.extend({
    className: 'tiptap-editor',

    editor: null,
    default_content: '',

    events: {
        'click .toolbar-btn-heading'  : 'onClickHeadingBtn',
        'click .toolbar-btn-bold'     : 'onClickBoldBtn',
        'click .toolbar-btn-italic'   : 'onClickItalicBtn',
        'click .toolbar-btn-bullet'   : 'onClickBulletBtn',
        'click .toolbar-btn-order'    : 'onClickOrderBtn',
        'click .toolbar-btn-code'     : 'onClickCodeBtn',
        'click .toolbar-btn-link'     : 'onClickLinkBtn',
        'click .toolbar-dropdown-body': 'onClickDropdownBody',
        'submit form.toobar-form-link': 'onSaveLink',
        'click .unlink'               : 'onClickUnlinkBtn',
    },

    dom_handlers: {
        onClickHeadingBtn: function (e) {
            this.editor.chain().focus().toggleHeading({ level: 2 }).run();
            this.$el.find('.tiptap-editor-toolbar button').removeClass('active');
            $(e.currentTarget).toggleClass('active', this.editor.isActive('heading', { level: 2 }));
        },
        onClickBoldBtn: function (e) {
            this.editor.chain().focus().toggleBold().run();
            this.$el.find('.tiptap-editor-toolbar button').removeClass('active');
            $(e.currentTarget).toggleClass('active', this.editor.isActive('bold'));
        },
        onClickItalicBtn: function (e) {
            this.editor.chain().focus().toggleItalic().run();
            this.$el.find('.tiptap-editor-toolbar button').removeClass('active');
            $(e.currentTarget).toggleClass('active', this.editor.isActive('italic'));
        },
        onClickBulletBtn: function (e) {
            this.editor.chain().focus().toggleBulletList().run();
            this.$el.find('.tiptap-editor-toolbar button').removeClass('active');
            $(e.currentTarget).toggleClass('active', this.editor.isActive('bulletList'));
        },
        onClickOrderBtn: function (e) {
            this.editor.chain().focus().toggleOrderedList().run();
            this.$el.find('.tiptap-editor-toolbar button').removeClass('active');
            $(e.currentTarget).toggleClass('active', this.editor.isActive('orderedList'));
        },
        onClickCodeBtn: function (e) {
            this.editor.chain().focus().toggleCodeBlock().run();
            this.$el.find('.tiptap-editor-toolbar button').removeClass('active');
            $(e.currentTarget).toggleClass('active', this.editor.isActive('codeBlock'));
        },
        onClickLinkBtn: function (e) {
            // Get the current link attributes
            var link_attrs = this.editor.getAttributes('link');
            var previousUrl = link_attrs.href || '';

            // Extend selection to ensure the entire link text is selected
            this.editor.commands.extendMarkRange('link');
            var extendedSelection = this.editor.state.selection;
            var select_text = this.editor.state.doc.textBetween(extendedSelection.from, extendedSelection.to, ' ').trim();

            this.$el.find('.tiptap-editor-toolbar button').removeClass('active');
            $(e.currentTarget).toggleClass('active', this.editor.isActive('link'));

            this.$el.find('.toolbar-dropdown-link input[name="link_text"]').val(select_text);
            this.$el.find('.toolbar-dropdown-link input[name="link_url"]').val(previousUrl);

            setTimeout(() => {
                this.$el.find('.toolbar-dropdown-link input[name="link_text"]').trigger("focus");
            }, 0);

            this.$el.find('.unlink').prop('disabled', !this.editor.isActive('link'));
        },

        onClickDropdownBody: function (e) {
            e.stopPropagation();
        },

        onSaveLink: function (e) {
            e.preventDefault();

            var link_attrs = this.editor.getAttributes('link');

            this.editor.commands.extendMarkRange('link');
            var extendedSelection = this.editor.state.selection;
            var select_text = this.editor.state.doc.textBetween(extendedSelection.from, extendedSelection.to, ' ').trim();

            var text = this.$el.find('.toolbar-dropdown-link input[name="link_text"]').val().trim();
            var url = this.$el.find('.toolbar-dropdown-link input[name="link_url"]').val().trim();

            this.$el.find('.toolbar-dropdown-link .toolbar-dropdown-body').hide();

            // If URL is empty, remove the link
            if (!url) {
                this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
                this.$el.find('.toolbar-btn-link').toggleClass('active', this.editor.isActive('link'));
                return;
            }

            // If the selection is already inside a link but has no selected text, update only the URL
            if (link_attrs.href && !select_text) {
                this.editor.chain().focus().updateAttributes("link", { href: url }).run();
            } else {
               // If no text is provided, use the URL as the default text
                if (!text) {
                    text = url;
                }

                // Insert or update the link with the new text and URL
                this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).insertContent(text).run();
            }

            this.$el.find('.toolbar-btn-link').toggleClass('active', this.editor.isActive('link'));

            this.$el.find('.toolbar-dropdown-link input[name="link_text"]').val('');
            this.$el.find('.toolbar-dropdown-link input[name="link_url"]').val('');
        },


        onClickUnlinkBtn: function (e) {
            this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
            this.$el.find('.toolbar-dropdown-link .toolbar-dropdown-body').hide();
        },
    },

    initialize: function (options) {
        this.default_content = options.default_content;
    },

    getMarkdownContent: function() {
        return this.editor.storage.markdown.getMarkdown();
    },

    renderTiptap: function () {
        this.editor = new Editor({
            element: this.$el.find('.tiptap-editor-content').get(0),
            extensions: [
                StarterKit.configure({
                    heading: {
                        levels: [2],
                    },
                }),
                Markdown,
                Link.configure({
                    openOnClick: false // Disable default click behavior
                }),
            ],
            content: this.default_content,
            editorProps: {
                handlePaste: (view, event) => {
                    event.preventDefault();
                    const text = event.clipboardData.getData('text/plain');
                    this.editor.commands.insertContent(text);
                    return true;
                },
            },
            onSelectionUpdate: ({ editor }) => {
                this.$el.find('.toolbar-btn-heading').toggleClass('active', this.editor.isActive('heading', { level: 2 }));
                this.$el.find('.toolbar-btn-bold').toggleClass('active', this.editor.isActive('bold'));
                this.$el.find('.toolbar-btn-italic').toggleClass('active', this.editor.isActive('italic'));
                this.$el.find('.toolbar-btn-bullet').toggleClass('active', this.editor.isActive('bulletList'));
                this.$el.find('.toolbar-btn-order').toggleClass('active', this.editor.isActive('orderedList'));
                this.$el.find('.toolbar-btn-code').toggleClass('active', this.editor.isActive('codeBlock'));
                this.$el.find('.toolbar-btn-link').toggleClass('active', editor.isActive('link'));
                this.$el.find('.toolbar-btn-unlink').prop('disabled', !editor.isActive('link'));
                this.$el.find('a').css('color', 'var(--portal-theme)');
            },
            onFocus: () => {
                this.$el.addClass('focus');
            },
            onBlur: () => {
                this.$el.removeClass('focus');
            },
            onUpdate: () => {
                this.trigger('update');
            }
        });
    },

    render: function () {
        var content = '';

        content +=
            '<div class="tiptap-editor-content"></div>' +
            '<div class="tiptap-editor-toolbar">' +
                '<button class="toolbar-btn-heading small square round tertiary" data-action="heading"><i class="fa-solid fa-heading"></i></button>' +
                '<button class="toolbar-btn-bold small square round tertiary" data-action="bold"><i class="fa-solid fa-bold"></i></button>' +
                '<button class="toolbar-btn-italic small square round tertiary" data-action="italic"><i class="fa-solid fa-italic"></i></button>' +
                '<button class="toolbar-btn-bullet small square round tertiary" data-action="bulletList"><i class="fa-solid fa-list"></i></button>' +
                '<button class="toolbar-btn-order small square round tertiary" data-action="orderedList"><i class="fa-solid fa-list-ol"></i></button>' +
                '<button class="toolbar-btn-code small square round tertiary" data-action="codeBlock"><i class="fa-solid fa-code"></i></button>' +
                '<div class="button-dropdown toolbar-dropdown toolbar-dropdown-link">' +
                    '<button type="button" class="dropdown-select toolbar-btn-link small square round tertiary" data-action="link"><i class="fa-solid fa-link"></i></button>' +
                    '<div class="toolbar-dropdown-body form-fluid">' +
                        '<form class="toobar-form-link">' +
                            '<div class="row borderless">' +
                                '<div class="field-label">Link Text</div>' +
                                '<input type="text" class="solid medium" name="link_text">' +
                            '</div>' +
                            '<div class="row borderless">' +
                                '<div class="field-label">URL</div>' +
                                '<input type="text" class="solid medium" name="link_url" placeholder="https://">' +
                            '</div>' +
                            '<div class="borderless">' +
                                '<button type="submit" class="save-link primary small">Save</button>' +
                                '<button type="button" class="unlink primary small" disabled>Unlink</button>' +
                            '</div>' +
                        '</form>' +
                    '</div>' +
                '</div>' +
            '</div>';

        this.$el.html(content);

        this.renderTiptap();

        return this;
    },
});